export enum AuthMethods {
	EMAIL = 'email',
	PHONE_NUMBER = 'phone_number',
}
